import { POST, GET } from 'utils/useApi';
import { ITrialCallInvitation, Booking, TZoomBooking } from 'types';
import { getQueryFromObj } from './request';

export const sendTrialBooking = (data: Partial<ITrialCallInvitation>) => {
  return POST('v2/customer/trials-calls/', data, true);
};

export const getTutorBookings = (query?: Record<string, any>) => {
  return GET<Booking[]>(`v2/tutor/bookings/${getQueryFromObj(query)}`, true);
};

export const getCustomerBookings = (query?: Record<string, any>) => {
  return GET<Booking[]>(`v2/customer/bookings/${getQueryFromObj(query)}`, true);
}

export async function rejectTrialInvitation(
  bookingId: number
) {
  return POST(`v2/tutor/bookings/${bookingId}/cancel/`, {}, true);
};

export async function rejectTrialInvitationCustomer(
  bookingId: number
) {
  return POST(`v2/customer/bookings/${bookingId}/cancel/`, {}, true);
};

export async function confirmTrialInvitation(
  bookingId: number
) {
  return POST(`v2/tutor/invitations/${bookingId}/accept_invitation/`, {}, true);
};

export async function getBookingById(
  bookingId: number
) {
  return POST<TZoomBooking>(`v2/zoommeeting/${bookingId}`, {}, true);
};


